import { Directive, Input, OnChanges, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[appPasswordMatch][ngModel]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => PasswordMatchValidatorDirective),
    multi: true,
  }],
  standalone: false,
})
export class PasswordMatchValidatorDirective implements Validator, OnChanges {
  @Input('appPasswordMatch') appPasswordMatch: string;
  private control: AbstractControl;

  validate(control: AbstractControl): ValidationErrors | null {
    this.control = control;
    if (!control.value) {
      return null;
    }
    return control.value === this.appPasswordMatch
      ? null
      : { passwordMismatch: true };
  }

  ngOnChanges(): void {
    this.control?.updateValueAndValidity();
  }
}
